import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';
import EditorRow from '../EditorRow';

const ClearNumberArrows = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

const StyledAdornment = styled(InputAdornment)`
  && {
    & > p {
      font-family: Basier Circle;
      font-size: 15px;
      color: #797979;
      padding-bottom: 2px;
    }
  }
`;

const ErrorMessage = styled.p`
  font-family: Basier Circle;
  font-size: 12px;
  color: #d32f2f;
  margin: 4px 0 0 0;
  line-height: 1;
`;

const StyledInput = styled(Input)`
  ${props =>
    props.hasError &&
    `
    & input {
      border-color: #d32f2f !important;
      color: #d32f2f;
    }
  `}
`;

// value is stored as a decimal 0–1 (e.g. 0.2 for 20%), displayed as a percentage
const toDisplay = v => {
  if (v == null) return '';
  const pct = v * 100;
  return String(parseFloat(pct.toFixed(4)));
};

const VatRateField = props => {
  const { id, className, value, onChange, disabled, hideLabel, label, width } =
    props;

  const [rawValue, setRawValue] = useState(toDisplay(value));

  const hasError =
    value !== undefined && value !== null && (value < 0 || value > 1);
  const errorMessage = hasError ? 'Must be between 0 and 100%' : '';

  const rawOnChange = e => {
    const input = e.target.value;
    setRawValue(input);
    const parsed = parseFloat(input);
    const stored = isNaN(parsed)
      ? undefined
      : parseFloat((parsed / 100).toFixed(6));
    onChange({ ...e, target: { ...e.target, value: stored } });
  };

  return (
    <EditorRow className={className} width={width || 90}>
      <label htmlFor={id} style={{ display: hideLabel ? 'none' : '' }}>
        {label || 'VAT %'}
      </label>
      <ClearNumberArrows>
        <StyledInput
          hasError={hasError}
          id={id}
          onChange={rawOnChange}
          value={rawValue}
          placeholder="e.g. 20"
          disabled={disabled}
          size="small"
          type="number"
          endAdornment={<StyledAdornment position="end">%</StyledAdornment>}
          inputProps={{ min: '0', max: '100', step: '0.1' }}
          fullWidth={true}
          style={{ width: '70px' }}
        />
      </ClearNumberArrows>
      {hasError && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </EditorRow>
  );
};

VatRateField.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hideLabel: PropTypes.bool,
  label: PropTypes.string,
};

VatRateField.defaultProps = {
  disabled: false,
  value: undefined,
  label: undefined,
};

export default VatRateField;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/VatRateField/index.jsx